export type MeasurementUnit = 'km' | 'mi';

export const KM_TO_MI = 0.621371;
export const MEASUREMENT_UNIT_EVENT = 'fleetlume:measurement-unit-change';

export function getMeasurementUnit(): MeasurementUnit {
  const saved = localStorage.getItem('measurementUnit') ?? localStorage.getItem('odometerUnit');
  return saved === 'mi' ? 'mi' : 'km';
}

export function setMeasurementUnit(unit: MeasurementUnit): void {
  localStorage.setItem('measurementUnit', unit);
  // Keep the legacy key synchronized for existing installations.
  localStorage.setItem('odometerUnit', unit);
  window.dispatchEvent(new CustomEvent<MeasurementUnit>(MEASUREMENT_UNIT_EVENT, { detail: unit }));
}

export function distanceValue(km: number, unit = getMeasurementUnit()): number {
  return unit === 'mi' ? km * KM_TO_MI : km;
}

export function speedValue(kmh: number, unit = getMeasurementUnit()): number {
  return unit === 'mi' ? kmh * KM_TO_MI : kmh;
}

export function distanceLabel(unit = getMeasurementUnit()): MeasurementUnit {
  return unit;
}

export function speedLabel(unit = getMeasurementUnit()): 'km/h' | 'mph' {
  return unit === 'mi' ? 'mph' : 'km/h';
}

export function formatDistance(km: number, options: {
  unit?: MeasurementUnit;
  maximumFractionDigits?: number;
  zeroAsDash?: boolean;
} = {}): string {
  const unit = options.unit ?? getMeasurementUnit();
  if (options.zeroAsDash && km <= 0) return '—';
  const value = distanceValue(km, unit);
  return `${value.toLocaleString(undefined, {
    maximumFractionDigits: options.maximumFractionDigits ?? 0,
  })} ${distanceLabel(unit)}`;
}

export function formatSpeed(kmh: number, unit = getMeasurementUnit()): string {
  return `${Math.round(speedValue(kmh, unit)).toLocaleString()} ${speedLabel(unit)}`;
}
